interface Scripts {
  name: string;
  src: string;
}
export const ScriptStore: Scripts[] = [
  {name: 'liqpay', src: 'https://static.liqpay.ua/libjs/checkout.js'}
];
